import { Notice } from "@/common/types/Notice";
import { request } from "@/common/api";
import { Buttons } from "@/components/atoms/Buttons";
import { useQuery } from "@tanstack/react-query";
import { AlertText } from "@/components/atoms/AlertText";
import { GET_NOTICE } from "@/common/querykeys";
import { ArticleList } from "@/components/molecules/ArticleList";
import { MainTemplate } from "@/components/templates/MainTemplate";
import { ReactComponent as IconArrow } from "@/styles/assets/svg/icon_arrow.svg";
import { Loading } from "@/components/atoms/Loading";
import { useRecoilValue } from "recoil";
import {
  guardianUserState,
  loginTypeState,
  studentUserState,
} from "@/common/states/user";

export const SettingNoticePage = () => {
  /** 📦 State Store */
  const loginType = useRecoilValue(loginTypeState);
  const studentInfo = useRecoilValue(studentUserState);
  const guardianInfo = useRecoilValue(guardianUserState);

  /** 📡 API Layer */
  // 전체 이벤트 및 공지 글 데이터 조회
  const { data: noticeData, isLoading } = useQuery<Notice[]>({
    queryKey: [GET_NOTICE, loginType],
    queryFn: async () => {
      const userId = loginType === "student" ? studentInfo.id : guardianInfo.id;

      return await request<Notice[]>({
        method: "GET",
        url: "/notice",
        params: {
          userId,
        },
      });
    },
  });

  return (
    <>
      {isLoading ? (
        <Loading />
      ) : (
        <>
          {noticeData && noticeData.length > 0 ? (
            <MainTemplate
              nav={false}
              subPage={true}
              menuBtn={false}
              buttonLeft={
                <Buttons
                  type="button"
                  size="headerTextIcon"
                  layout="text"
                  color="bright100"
                  icon={<IconArrow />}
                  label="설정"
                  onClick={() => window.history.back()}
                />
              }
              pageTitle="이벤트 및 공지"
            >
              <ArticleList data={noticeData} />
            </MainTemplate>
          ) : (
            <MainTemplate
              nav={false}
              subPage={true}
              menuBtn={false}
              buttonLeft={
                <Buttons
                  type="button"
                  size="headerTextIcon"
                  layout="text"
                  color="bright100"
                  icon={<IconArrow />}
                  label="설정"
                  onClick={() => window.history.back()}
                />
              }
              pageTitle="이벤트 및 공지"
            >
              <AlertText subText="현재 진행중인 이벤트 및 공지사항이 없습니다." />
            </MainTemplate>
          )}
        </>
      )}
    </>
  );
};
